import type { HttpService } from '@empathyco/playboard-core-domain'
import type { ContextProvider } from '../providers'
import type {
  PlatformRelatedPromptsPreviewItems,
  RelatedPromptsPreviewItems,
  RelatedPromptsPreviewService,
} from './interfaces'
import { interpolate } from '@empathyco/x-adapter'
import { inject, injectable } from 'inversify'
import { TYPES } from '../config/inversify.types'

@injectable()
export class PlatformRelatedPromptsPreviewService implements RelatedPromptsPreviewService {
  public constructor(
    @inject(TYPES.HttpService) protected httpService: HttpService,
    @inject(TYPES.RelatedPromptsPreviewUrl) protected url: string,
    @inject(TYPES.ContextProvider) protected contextProvider: ContextProvider,
    protected endpoint = '/query/{instance}/search',
  ) {}

  async listRelatedPromptsPreview(params: {
    lang: string
    query: string
  }): Promise<PlatformRelatedPromptsPreviewItems[]> {
    const response = await this.httpService.get<RelatedPromptsPreviewItems>(
      this.buildRequestUrl(),
      {
        addAccessToken: true,
        parameters: {
          ...params,
          internal: true,
        },
      },
    )

    return (
      response.data?.catalog.content?.map(item => ({
        id: item.__externalId ?? '',
        name: item.__name ?? '',
        imageUrl: item.__images?.[0] ?? '',
      })) ?? []
    )
  }

  private buildRequestUrl(parameters: Record<string, any> = {}): string {
    const url = `${this.url}${this.endpoint}`
    const { instanceId: instance } = this.contextProvider()
    if (!instance) {
      throw new Error('instance is not defined')
    }
    return interpolate(url, { instance, ...parameters })
  }
}
